import React, { FC } from 'react';
import { useTheme } from 'styled-components';
import { SkeletonLoader } from '../../UI';
import { SlideRow, SLIDE_ROW_SKELETON_HEIGHT, SLIDE_ROW_SKELETON_COUNT } from './SlideRow';
import { SlideColumn, formatSlideCount } from './SlideColumn';
import { UploadedSlide } from './UploadNewAsset';

interface UploadedSlidesProps {
  slides: UploadedSlide[];
  hasError?: boolean;
  viewStateKey?: string;
  isLoading?: boolean;
}

export const UploadedSlides: FC<UploadedSlidesProps> = ({ slides, hasError, viewStateKey, isLoading }) => {
  const theme = useTheme();

  return (
    <SlideColumn title="Uploaded Slides" subtitle={formatSlideCount(slides.length)}>
      {!isLoading && slides.length > 0
        ? slides.map((slide) => (
            <SlideRow
              key={slide.slide_number}
              slideNumber={slide.slide_number}
              thumbnailUrl={slide.thumbnail_location}
              thumbnailBase64={slide.thumbnail_base64}
              viewStateKey={viewStateKey}
              title={slide.slide_title}
            />
          ))
        : hasError
        ? null
        : Array.from({ length: SLIDE_ROW_SKELETON_COUNT }).map((_, index) => (
            <SkeletonLoader
              key={index}
              count={1}
              height={SLIDE_ROW_SKELETON_HEIGHT}
              width="100%"
              borderRadius={theme.radius.card}
              single
            />
          ))}
    </SlideColumn>
  );
};
